"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecodableAgent = void 0;
const provider_1 = require("../provider");
const local_1 = require("../provider/local");
class DecodableAgent {
    constructor(opts) {
        this.provider = opts.provider;
    }
    static withLocalProvider() {
        const provider = new local_1.LocalProvider();
        return new DecodableAgent({ provider });
    }
    static withDataDogProvider(config) {
        const provider = new provider_1.DatadogProvider();
        provider.init(config);
        return new DecodableAgent({ provider });
    }
    init(...args) {
        this.provider.init(...args);
    }
    cleanup(...args) {
        this.provider.cleanup(...args);
    }
    recordInfo(message, messageContext) {
        this.provider.recordInfo(message, messageContext);
    }
    recordWarning(message, messageContext, error) {
        this.provider.recordWarn(message, messageContext, error);
    }
    recordError(message, error, messageContext) {
        this.provider.recordError(message, error, messageContext);
    }
    setUser(user) {
        this.provider.setUser(user);
    }
    setUserProperty(key, value) {
        this.provider.setUserProperty(key, value);
    }
}
exports.DecodableAgent = DecodableAgent;
